import api from "./API";

export const parametersService = async (data) => {
  try {
    return await api.post(`/fetch-parameters`, data);
  } catch (error) {
    console.log(error);
  }
};
